
import { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const newsData = [
  {
    id: 1,
    date: '2024.03.15',
    title: '',
    category: 'お知らせ',
    image:
      'https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/746550d7d9b465d44ef22b9903dd3794.jpeg',
    link: '#',
  },
];

export default function News() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const titleAnim = useScrollAnimation();
  const cardAnim = useScrollAnimation({ rootMargin: '0px 0px -60px 0px' });

  const getItemsPerView = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 1;
      if (window.innerWidth < 1024) return 2;
      return 4;
    }
    return 4;
  };

  const [itemsPerView, setItemsPerView] = useState(getItemsPerView);

  useEffect(() => {
    const handleResize = () => {
      try {
        setItemsPerView(getItemsPerView());
      } catch (e) {
        console.error('Failed to recalculate items per view:', e);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      Math.min(newsData.length - itemsPerView, prev + 1)
    );
  };

  const safeItemsPerView = itemsPerView > 0 ? itemsPerView : 1;

  return (
    <section id="news" className="py-12 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleAnim.ref}
          className={titleAnim.isVisible ? 'anim-fade-up' : 'anim-hidden'}
        >
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3 md:mb-4">
              <img
                src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/758ef2cf37f252b690d6ec189d9cae34.png"
                alt=""
                className="h-6 md:h-8"
              />
              <h2 className="text-3xl md:text-5xl font-black text-gray-900">
                <span className="text-teal-500">ニュース</span>
              </h2>
            </div>
            <p className="text-xs md:text-sm text-gray-500 tracking-widest">
              News
            </p>
          </div>
        </div>

        <div
          ref={cardAnim.ref}
          className={`relative ${cardAnim.isVisible ? 'anim-fade-up anim-delay-200' : 'anim-hidden'}`}
        >
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / safeItemsPerView)
                }%)`,
              }}
            >
              {newsData.map((news) => (
                <div
                  key={news.id}
                  className="flex-shrink-0 px-2 md:px-3"
                  style={{ width: `${100 / safeItemsPerView}%` }}
                >
                  <a href={news.link} className="block group cursor-pointer">
                    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                      <div className="relative w-full aspect-[4/3] overflow-hidden">
                        <img
                          src={news.image}
                          alt={news.title}
                          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-3 md:p-4">
                        <p className="text-xs text-gray-500 mb-2">{news.date}</p>
                        <h3 className="text-sm font-medium text-gray-900 mb-3 line-clamp-2">
                          {news.title}
                        </h3>
                        <span className="inline-block px-3 py-1 bg-teal-500 text-white text-xs rounded-full whitespace-nowrap">
                          {news.category}
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>

          {newsData.length > safeItemsPerView && (
            <div className="flex items-center justify-center gap-4 mt-6 md:mt-8">
              <button
                onClick={handlePrev}
                disabled={currentIndex === 0}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-black text-white disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-s-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                disabled={currentIndex >= newsData.length - safeItemsPerView}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-black text-white disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-s-line text-xl"></i>
              </button>
            </div>
          )}

          <div className="text-center mt-6 md:mt-8">
            <a
              href="#news-list"
              className="inline-flex items-center px-6 md:px-8 py-3 bg-black text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              最新情報一覧
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
